const riot = require('riot');

riot.tag2('page-deposit_histories', '<div class="s-full f fclm"> <div class="s-full f fclm"> <div class="flex-fixed" data-is="module-page-header" title="残高/入金履歴" back="{true}" breadcrumbs="{breadcrumbs}"></div> <div class="f fclm flex-auto w-full px40 py36 bg-pale_gray"> <div class="flex-fixed section-padding bg-white rounded-8 elevation-default-low mb32"> <div class="ts-hxs text-gray_30 mb8">ポイント購入代金 購入可能残高</div> <div class="ts-pm text-navy">{(totalDepositAmount - totalConsumedAmount).toLocaleString()}円</div> </div> <div class="f fclm w-full flex-height-auto rounded-8 bg-white elevation-default-low overflow-hidden"> <div class="max-height-500 w-full" data-is="module-table" schemas="{depositHistoriesShcema}" items="{pointDepositHistories}"></div> <div class="flex-fixed f fr px28"> <div ref="pagination" data-is="atom-pagination" pagination="{pagination}"></div> </div> </div> </div> </div> </div>', 'page-deposit_histories,[data-is="page-deposit_histories"]{display:block}', '', function(opts) {
    this.limit = 50;
    this.preload = async ({req, res}) => {
      if (spat.isNode) return;
      this.update();
      var company_id = req.params.company_id;
      var promises = [
        app.api.child(`companies/${company_id}/point_deposit_histories`).get({limit: this.limit, offset: 0}),
        app.api.child(`companies/${company_id}/point_deposit_histories/summary`).get(),

      ];
      var [{ point_deposit_histories, pagination }, { total_deposit_amount, total_consumed_amount }] = await Promise.all(promises);
      this.pointDepositHistories = point_deposit_histories;
      this.pagination = pagination;

      this.totalDepositAmount = total_deposit_amount;

      this.totalConsumedAmount = total_consumed_amount;
      this.update();

      var breadcrumbs = [
        {
          link: `/app/companies/${company_id}/projects`,
          label: "ダッシュボード",
        },
      ];

      return {
        breadcrumbs,
        companyId: company_id,
      };
    };

    this.on('mount', () => {

      this.refs.pagination.on('paginationchange', async (offset_type) => {
        var indicator = spat.modal.indicator();
        var offset = this.pagination[offset_type];
        try {
          var {point_deposit_histories, pagination} = await app.api.child(`companies/${this.companyId}/point_deposit_histories`).get({limit: this.limit, offset });
          this.pointDepositHistories = point_deposit_histories;
          this.pagination = pagination;
          this.update();
        }
        catch (e) {
          console.error(e);
          spat.modal.alert(e.message);
        }
        finally {
          indicator.close();
        }
      });
    });

    this.depositHistoriesShcema = [
      {
        id: 'apply_at',
        label: '反映日',
        class: 'w140 flex-fixed',
        align: 'left',
        getText: (v) => dayjs(v).format('YYYY-MM-DD'),
      },
      {
        id: 'deal_type',
        label: '金額(円)',
        class: 'w104 flex-fixed',
        align: 'right',
        getText: (v, item) => {
          let amount = item.amount.toLocaleString();
          return v === 'refund' ? '-' + amount : amount;
        },
      },
      {
        id: 'reason',
        label: 'コメント',
        class: 'w0 flex-auto',
        align: 'left',
      },
    ];
});